import { CHOOSE_PATIENT_TYPE_SERVICE_ADVISE } from "app/appConfig";
import GlobitsVNDCurrencyInput from "app/common/form/GlobitsVNDCurrencyInput";
import GlobitsVNDCurrencyInputOnblur from "app/common/form/GlobitsVNDCurrencyInputOnblur";
import { useFormikContext } from "formik";
import { observer } from "mobx-react";
import { memo } from "react";

const SuggestionPrice = ({
  suggestedPrice,
  onSelect,
  patientTypeServiceSelected,
  nameSpace,
  handleBlurPrice,
}) => {
  const { setFieldValue } = useFormikContext();
  return (
    <>
      {CHOOSE_PATIENT_TYPE_SERVICE_ADVISE && suggestedPrice?.length > 0 ? (
        <div className="suggestion-box">
          {suggestedPrice?.map((msg, idx) => {
            let isActive =
              patientTypeServiceSelected &&
              patientTypeServiceSelected?.id === msg?.patientTypeService?.id;
            return (
              <>
                {msg?.price && (
                  <div
                    key={idx}
                    onClick={() => onSelect(msg)}
                    className={`suggestion-item ${isActive ? "active" : ""}`}
                  >
                    {/* <div className="suggestion-name">{msg?.name}</div> */}

                    <div className="suggestion-detail">
                      <>
                        {isActive && <span className="price-icon">💰</span>}
                        <span className="suggestion-name">
                          {msg?.price?.toLocaleString()}đ
                        </span>
                        {msg?.patientTypeService?.name && (
                          <span className="suggestion-price">
                            – {msg?.patientTypeService?.name}
                          </span>
                        )}
                      </>
                    </div>
                  </div>
                )}
              </>
            );
          })}
        </div>
      ) : (
        <></>
      )}
      <div className="mb-1">
        <GlobitsVNDCurrencyInputOnblur
          name={nameSpace}
          placeholder="Nhập giá"
          onBlur={async (value) => {
            // setFieldValue(nameSpace, price);
            await handleBlurPrice(value);
          }}
        />
      </div>
    </>
  );
};

export default memo(observer(SuggestionPrice));
